import {Component, Input, OnInit} from '@angular/core';
import {InfluencerCampaignPost} from '../../../models/influencer-campaign';

@Component({
  selector: 'campaign-post-list',
  templateUrl: './campaign-post-list.component.html',
  styleUrls: ['./campaign-post-list.component.scss']
})
export class CampaignPostListComponent implements OnInit {
  @Input()
  isShow: boolean;
  @Input()
  postList: InfluencerCampaignPost[] = [];
  @Input()
  campaignId: number;

  ngOnInit() {
  }

}



// WEBPACK FOOTER //
// ./src/app/fb-testing-page/campaign-post-list/campaign-post-list.component.ts